import {Messages} from "../messages/Messages";
import {bootstrapModal} from "../lib/bootstrapModal";
import {escapeHTML} from "../lib/escapeHTML";
import {apiPost} from "../lib/SecuredAjax";
import {AppConfig} from "../AppConfig";
import {fetchJson, isAjaxResponseOk, toastFetchError} from "../lib/fetch";
import {showToastInfo} from "../lib/boostrapToast";
import {toggleDisabled, toggleHidden} from "../lib/domFunctions";
import {PositionSelectOption} from "../dto/com.rico.sb2.service.positions";
import {coalesce} from "../lib/coalesce";

const messages = new Messages();

export class AssignContainerTargetPosition {
	private readonly containerId: number
	private readonly currentPosition: number | null
	private readonly currentChoice: number | null

	constructor(containerId: number, currentPosition: number | null, currentChoice: number | null) {
		this.containerId = containerId
		this.currentChoice = currentChoice
		this.currentPosition = currentPosition
	}

	execute(position: number | null): Promise<void> {
		return new Promise((resolve, reject) => {
			apiPost(`${AppConfig.CP}/op/assignTargetPosition`, {container: this.containerId, position})
				.then(res => isAjaxResponseOk(res) ? res.value : Promise.reject(res.message))
				.then(success => {
					if (!success) return Promise.reject(500)

					showToastInfo(messages.get('AssignContainerTargetPosition.completeNotice'))
					resolve()
				})
				.catch(error => {
					toastFetchError(error);
					reject();
				})
		})
	}

	showModal(success?: Function) {
		const {modal, content, buttonOk, buttonOkClickStart, buttonOkClickFinish} = bootstrapModal({
			title: messages.get('AssignContainerTargetPosition.title', this.containerId),
			body: this.renderForm(),
			buttonOk: messages.get('button.send')
		});
		modal.show();

		const ok = buttonOk!!;
		const positionSelect = content.querySelector<HTMLSelectElement>('select[name="position"]')!!;

		ok.addEventListener('click', () => {
			const position = positionSelect.value == '' ? null : parseInt(positionSelect.value);
			buttonOkClickStart();

			this.execute(position)
				.then(() => {
					modal.hide()
					if (success) success()
				})
				.catch(buttonOkClickFinish)
		})

		function loadingStop() {
			content.querySelector('[data-bind="loading"]')?.remove()
		}

		fetchJson(`${AppConfig.CP}/op/listUnloadTargets?container=${this.containerId}`)
			.then((res: any) => isAjaxResponseOk(res) ? res.value : Promise.reject(500))
			.then((positions: PositionSelectOption[]) => {
				let options = `<option value="" ${!this.currentChoice ? ' selected' : ''}>${escapeHTML(messages.get('UpdateContainerMessage.enteredTargetPosition.any'))}</option>`;
				const currentSuffix = ` ${escapeHTML(messages.get("UpdateContainerMessage.enteredTargetPosition.currentSuffix"))}`
				if (positions.length > 0) {
					options += positions
						.sort((a, b) => coalesce(a.label, '').localeCompare(b.label))
						.map((p: any) => `<option value="${p.id}" ${this.currentChoice == p.id ? ' selected' : ''}>${p.id}: ${escapeHTML(p.label)}${this.currentPosition == p.id ? currentSuffix : ''}</option>`)
						.join("")
				}
				positionSelect.innerHTML = options;
				toggleHidden(content.querySelector('[data-bind="select"]')!!, false)
			})
			.catch(toastFetchError)
			.then(loadingStop)
	}

	private renderForm(): string {
		return `
            <div class="text-center" data-bind="loading"><div class="lds-dual-ring"></div></div>        
            <div class="hidden text-center" data-bind="emptyMessage">${escapeHTML(messages.get('AssignContainerTargetPosition.noAvailablePositions'))}</div>
            <div class="hidden" data-bind="select"><select name="position" class="form-select" required></select></div>
        `
	}
}
